var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReminders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1533 21.3522C17.0361 21.5492 16.8679 21.7128 16.6655 21.8264C16.4631 21.9401 16.2336 22 16 22C15.7664 22 15.5369 21.9401 15.3345 21.8264C15.1321 21.7128 14.9639 21.5492 14.8467 21.3522M20 13.1607C20 12.0572 19.5786 10.9989 18.8284 10.2187C18.0783 9.43836 17.0609 9 16 9C14.9391 9 13.9217 9.43836 13.1716 10.2187C12.4214 10.9989 12 12.0572 12 13.1607C12 18.0149 10 19.4018 10 19.4018H22C22 19.4018 20 18.0149 20 13.1607Z",
    stroke: "#7D899D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4H3L3 5H4V4ZM3 3C2.44772 3 2 3.44772 2 4V5C2 5.55228 2.44772 6 3 6H4C4.55228 6 5 5.55228 5 5V4C5 3.44772 4.55228 3 4 3H3ZM7 4.5C7 4.22386 7.22386 4 7.5 4H16.5C16.7761 4 17 4.22386 17 4.5C17 4.77614 16.7761 5 16.5 5H7.5C7.22386 5 7 4.77614 7 4.5ZM7 9.5C7 9.22386 7.22386 9 7.5 9H11.396C11.1092 9.30946 10.8574 9.64478 10.643 10H7.5C7.22386 10 7 9.77614 7 9.5ZM9.75103 13.9998H7.5C7.22386 13.9998 7 14.2236 7 14.4998C7 14.7759 7.22386 14.9998 7.5 14.9998H9.68073C9.7122 14.6825 9.73606 14.3494 9.75103 13.9998ZM3 9H4V10H3L3 9ZM2 9C2 8.44772 2.44772 8 3 8H4C4.55228 8 5 8.44772 5 9V10C5 10.5523 4.55228 11 4 11H3C2.44772 11 2 10.5523 2 10V9ZM4 14H3L3 15H4V14ZM3 13C2.44772 13 2 13.4477 2 14V15C2 15.5523 2.44772 16 3 16H4C4.55228 16 5 15.5523 5 15V14C5 13.4477 4.55228 13 4 13H3Z",
    fill: "#7D899D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminders);
export default __webpack_public_path__ + "static/media/reminders.15c23ed7.svg";
export { ForwardRef as ReactComponent };